import { isServerCheck } from './isServerCheck';

export function isPreviewEnv() {
  if (isServerCheck()) {
    return false;
  }

  return Boolean(
    window.location.origin.match(
      /^https:\/\/[\w\d-_]+\.previews\.www-staging\.depop\.com$/
    )
  );
}
